import React, {useState} from "react";
import serviceImg from "../../assets/images/coding-img.png";
import TopBanner from "../../components/TopBanner";
import {useTranslation} from "react-i18next";
import appSer from "../../assets/images/appSer.png";
import service1 from "../../assets/images/ser-1.png";
import service2 from "../../assets/images/ser-2.png";
import service3 from "../../assets/images/ser-3.png";
import service4 from "../../assets/images/ser-4.png";
import service5 from "../../assets/images/ser-5.png";
import service6 from "../../assets/images/ser-6.png";
import service7 from "../../assets/images/ser-7.png";
import appSer1 from "../../assets/images/ser-app-1.png";
import appSer2 from "../../assets/images/ser-app-2.png";
import appSer3 from "../../assets/images/ser-app-3.png";
import appSer4 from "../../assets/images/ser-app-4.png";
import appSer5 from "../../assets/images/ser-app-5.png";
import conSer1 from "../../assets/images/ser-con-1.png";
import conSer2 from "../../assets/images/ser-con-2.png";
import conSer3 from "../../assets/images/ser-con-3.png";
import conSer4 from "../../assets/images/ser-con-4.png";
import conSer from "../../assets/images/conSer.png";
import dbImg from "../../assets/images/infra-db.png";
import transSer from "../../assets/images/transSer.png";
import eConSer from "../../assets/images/eConSer.png";
import eConSer1 from "../../assets/images/ser-eCon.png";
import recruitTrainSer from "../../assets/images/trainSer.png";
import trainSer1 from "../../assets/images/ser-rt-1.png";
import trainSer2 from "../../assets/images/ser-rt-2.png";
import infraSer from "../../assets/images/infraSer.png";
import infraSer1 from "../../assets/images/ser-infra-1.png";
import rdSer from "../../assets/images/aiSer.png";
import rdSer2 from "../../assets/images/ser-ai-2.png";

export declare type ServiceItemProps = {
    id: string;
    title: string;
    content: string;
    serviceImg: string;
    side: boolean;
    image?: imageItemProps[];
}

export declare type imageItemProps = {
    img: string;
    imgName: string;
}

const ServiceItem: React.FC<ServiceItemProps> = (props: ServiceItemProps) => {
    const {t} = useTranslation();

    return (
        <div id={props.id} className="service-container">
            <div className={`${props.side ? "application-service-container xl-custom-1440:my-0" : "application-service-container-rightside"}`}>
                <div className="flex xl-custom-1280:flex-row flex-col gap-4 4xl-custom:gap-24">
                    <div
                        className={`${props.side ? "flex xl-custom-1280:flex-row flex-col gap-4 4xl-custom:gap-24" : "flex xl-custom-1280:flex-row-reverse flex-col-reverse gap-4 4xl-custom:gap-24"}`}>
                        <div
                            className={`${props.side ? "ourservice-first-container pb-8 w-full application-service-container-padding px-5 md:px-10 xl:pl-[50px] xl-custom-1280:pr-0 xl-custom-1280:w-[44%] 4xl-custom:w-[41.5%] py-8 xl-custom-1440:py-4 4xl-custom:py-24 4xl-custom:pl-24" : "ourservice-first-container py-4 w-full xl-custom-1280:w-[44%] 4xl-custom:w-[41.5%] application-service-container-padding-left px-5 md:px-10 xl-custom-1280:pl-0 xl-custom-1440:py-4 4xl-custom:py-24"}`}>

                            {/* Service content title */}
                            <h2 className="text-xl lg:text-2xl xl-custom-1280:text-3xl 4xl-custom:text-5xl font-primary text-primary pb-4 4xl-custom:pb-8">{t(props.title)}</h2>
                            {/* Service content description */}
                            <p className="text-base lg:text-lg font-primary text-primary leading-8">
                                {t(props.content)}
                            </p>

                            {/* Start services */}
                            <div className="mt-4 4xl-custom:mt-12">
                                {/* Service title */}
                                <h3 className="text-lg lg:text-21 font-bold text-secondary font-primary">Service</h3>


                                <div className="grid grid-cols-1 gap-x-4 gap-y-8 lg:gap-8 xl-custom-1280:gap-4 4xl-custom:gap-8 mt-4 md:grid-cols-2 xl:grid-cols-1 xl-custom-1280:grid-cols-2">
                                    {
                                        props.image?.map(
                                            imageItemProps => {
                                                return (
                                                    <div className="flex gap-4">
                                                        <div className="w-1/6 self-center">
                                                            {/* Service logo */}
                                                            <img className="" src={imageItemProps.img} alt={imageItemProps.img}/>
                                                        </div>
                                                        <div className="w-10/12 self-center">
                                                            {/* Service name */}
                                                            <p className="text-lg lg:text-21 work-break font-bold text-primary font-primary">{imageItemProps.imgName}</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        )
                                    }
                                </div>
                            </div>
                            {/* End services */}
                        </div>
                        {props.side ?
                            <div className="ourservice-last-container w-[55%] xl-custom-1280:w-[56%] 4xl-custom:w-[58.5%] lg-normal:mt-0 h-full self-end">
                                {/* Service content image */}
                                <img className="application-sevice-content-img h-full w-full" src={props.serviceImg} alt={props.id}/>
                            </div>
                            :
                            <div className="ourservice-last-container w-[55%] xl-custom-1280:w-[56%] 4xl-custom:w-[58.5%]">
                                {/* Service content image */}
                                <img className="w-full" src={props.serviceImg} alt={props.id}/>
                            </div>
                        }


                    </div>
                </div>
            </div>
        </div>
    )
};

const Service: React.FC<any> = () => {
    const {t} = useTranslation();
    const appImgItem: imageItemProps[] = [
        {
            img: appSer1,
            imgName: t('service:subTitle.img.app.1'),
        },
        {
            img: appSer2,
            imgName: t('service:subTitle.img.app.2'),
        },
        {
            img: appSer3,
            imgName: t('service:subTitle.img.app.3')
        },
        {
            img: appSer4,
            imgName: t('service:subTitle.img.app.4')
        },
        {
            img: appSer5,
            imgName: t('service:subTitle.img.app.5')
        }
    ];
    const consultImgItem: imageItemProps[] = [
        {
            img: conSer1,
            imgName: t('service:subTitle.img.con.1')
        },
        {
            img: conSer2,
            imgName: t('service:subTitle.img.con.2')
        },
        {
            img: conSer3,
            imgName: t('service:subTitle.img.con.3')
        },
        {
            img: conSer4,
            imgName: t('service:subTitle.img.con.4')
        },
    ];
    const transforImgItem: imageItemProps[] = [
        {
            img: dbImg,
            imgName: t('service:subTitle.img.transf.1')
        },
        {
            img: dbImg,
            imgName: t('service:subTitle.img.transf.2')
        },
        {
            img: dbImg,
            imgName: t('service:subTitle.img.transf.3')
        },
        {
            img: dbImg,
            imgName: t('service:subTitle.img.transf.4')
        },
        {
            img: dbImg,
            imgName: t('service:subTitle.img.transf.5')
        },
    ];
    const eConImgItem: imageItemProps[] = [
        {
            img: eConSer1,
            imgName: t('service:subTitle.img.eCon.1')
        },
    ];
    const recruitTrainImgItem: imageItemProps[] = [
        {
            img: trainSer1,
            imgName: t('service:subTitle.img.recruitTrain.1')
        },
        {
            img: trainSer2,
            imgName: t('service:subTitle.img.recruitTrain.2')
        }
    ];
    const infraImgItem: imageItemProps[] = [
        {
            img: infraSer1,
            imgName: t('service:subTitle.img.infra.1')
        },
        {
            img: appSer3,
            imgName: t('service:subTitle.img.infra.2')
        }
    ];
    const rdImgItem: imageItemProps[] = [
        {
            img: conSer4,
            imgName: t('service:subTitle.img.infra.1')
        },
        {
            img: rdSer2,
            imgName: t('service:subTitle.img.infra.2')
        }
    ];

    return (
        <>
            <div className={'description'}>
                <TopBanner image={serviceImg} title={t('header:btn_our_service')} altText={t('header:btn_our_service')} textColor={'white'}/>

                {/*service image title*/}
                <div className={'services-container my-16 lg:my-32'} id={'ourService'}>
                    <div className="container mx-auto">
                        <h2 className="text-xl lg:text-2xl xl-custom-1280:text-3xl 4xl-custom:text-5xl font-primary text-secondary pb-8 lg:pb-16 text-center">{t('header:btn_our_service')}</h2>
                        <div className="grid xl-custom-1280:grid-cols-7 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 xl:gap-10">
                            <div>
                                <img className="m-auto self-center" src={service1} alt="application services"/>
                                <p className="text-center text-primary text-base lg:text-lg font-primary pt-2 lg:pt-8">{t('service:subTitle.1')}</p>
                            </div>
                            <div>
                                <img className="m-auto self-center" src={service2} alt="consulting services"/>
                                <p className="text-center text-primary text-base lg:text-lg font-primary pt-2 lg:pt-8">{t('service:subTitle.2')}</p>
                            </div>
                            <div>
                                <img className="m-auto self-center" src={service3} alt="transformation services"/>
                                <p className="text-center text-primary text-base lg:text-lg font-primary pt-2 lg:pt-8">{t('service:subTitle.3')}</p>
                            </div>
                            <div>
                                <img className="m-auto self-center" src={service4} alt="e-Commerce"/>
                                <p className="text-center text-primary text-base lg:text-lg font-primary pt-2 lg:pt-8">{t('service:subTitle.4')}</p>
                            </div>
                            <div>
                                <img className="m-auto self-center" src={service5} alt="recruitment and training services"/>
                                <p className="text-center text-primary text-base lg:text-lg font-primary pt-2 lg:pt-8">{t('service:subTitle.5')}</p>
                            </div>
                            <div>
                                <img className="m-auto self-center" src={service6} alt="infrastructure services"/>
                                <p className="text-center text-primary text-base lg:text-lg font-primary pt-2 lg:pt-8">{t('service:subTitle.6')}</p>
                            </div>
                            <div>
                                <img className="m-auto self-center" src={service7} alt="R&amp;D"/>
                                <p className="text-center text-primary text-base lg:text-lg font-primary pt-2 lg:pt-8">{t('service:subTitle.7')}</p>
                            </div>
                        </div>
                    </div>
                </div>


                {/*service content*/}
                <section>
                    {/*appService*/}
                    <div className="xl-custom-1280:pb-8 xl-custom-1440:py-0">
                        <ServiceItem id={t('service:subTitle.img.app.id')} title={t('service:subTitle.1')} content={t('service:subTitle.content1')} serviceImg={appSer} image={appImgItem} side={true}/>
                    </div>
                    {/*consultingService*/}
                    <div className="pb-16 lg:pb-32 xl-custom-1280:pt-8 xl-custom-1440:pt-0">
                        <ServiceItem id={t('service:subTitle.img.con.id')} title={t('service:subTitle.2')} content={t('service:subTitle.content2')} serviceImg={conSer} image={consultImgItem}
                                     side={false}/>
                    </div>

                    {/*transformationService*/}
                    <div className="xl-custom-1280:pb-8 xl-custom-1440:py-0">
                        <ServiceItem id={t('service:subTitle.img.transf.id')} title={t('service:subTitle.3')} content={t('service:subTitle.content3')} serviceImg={transSer} image={transforImgItem}
                                     side={true}/>
                    </div>
                    {/*eCommerce*/}
                    <div className="pb-16 lg:pb-32 xl-custom-1280:pt-8 xl-custom-1440:pt-0">
                        <ServiceItem id={t('service:subTitle.img.eCon.id')} title={t('service:subTitle.4')} content={t('service:subTitle.content4')} serviceImg={eConSer} image={eConImgItem}
                                     side={false}/>
                    </div>

                    {/*RecruAndTrainService*/}
                    <div className="xl-custom-1280:pb-8 xl-custom-1440:py-0">
                        <ServiceItem id={t('service:subTitle.img.recruitTrain.id')} title={t('service:subTitle.5')} content={t('service:subTitle.content5')} serviceImg={recruitTrainSer}
                                     image={recruitTrainImgItem} side={true}/>
                    </div>
                    {/*InfraStrService*/}
                    <div className="pb-16 lg:pb-32 xl-custom-1280:pt-8 xl-custom-1440:pt-0">
                        <ServiceItem id={t('service:subTitle.img.infra.id')} title={t('service:subTitle.6')} content={t('service:subTitle.content6')} serviceImg={infraSer} image={infraImgItem}
                                     side={false}/>
                    </div>

                    {/*RD*/}
                    <div className="xl-custom-1280:pb-8 xl-custom-1440:py-0">
                        <ServiceItem id={t('service:subTitle.img.rd.id')} title={t('service:subTitle.7')} content={t('service:subTitle.content7')} serviceImg={rdSer} image={rdImgItem} side={true}/>
                    </div>

                </section>
            </div>
        </>
    )
}

export default Service;